import {
  styled,
} from '@volkswagen-onehub/components-core';
import { InfoCuota, RedirectCTAs }  from '.';
import React from 'react';
import { Offer } from 'src/types';

const CarlineModelCuotaInfoContainer = styled.div<{ numberOfOffers: number }>`
  height: 100%;
  display: flex;
  flex-wrap: always;
  flex-direction: column;
  justify-content: space-between;
  @media all and (min-width: 960px) {
    display: ${(props) => (props.numberOfOffers === 1 ? 'block' : 'flex')};
    height: ${(props) => (props.numberOfOffers === 1 ? 'fit-content' : '100%')};
  }
`;
export interface CarlineModelCuotaInfoProps {
  offer: Offer;
  numberOfOffers?: number;
}

export function CarlineModelCuotaInfo(props: CarlineModelCuotaInfoProps) {
  const { offer, numberOfOffers } = props;
  
  return (
    <CarlineModelCuotaInfoContainer numberOfOffers={numberOfOffers}>
      <InfoCuota offer={offer} />
      <RedirectCTAs offer={offer} />
    </CarlineModelCuotaInfoContainer>
  );
}
